var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12,0A12,12,0,1,0,24,12,12.035,12.035,0,0,0,12,0ZM10,17.414,4.586,12,6,10.586l4,4,8-8L19.414,8Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }